import { memo, useMemo } from "react";
import { PopupMenu, IMenuItem } from "../PopupMenu";

import LinkIcon from "@/common/images/icons/link.svg?react";
import EmbedIcon from "@/common/images/icons/embed.svg?react";
import RedditIcon from "@/components/icons-socials/reddit.svg?react";
import TwitterIcon from "@/components/icons-socials/twitter.svg?react";
import DiscordIcon from "@/components/icons-socials/discord.svg?react";

import "./ShareGifMenu.scss";

interface ShareGifMenuProps {
  onClick: (item: IMenuItem) => void;
  onClose: () => void;
}

export const ShareGifMenu = memo((props: ShareGifMenuProps) => {
  const menuItems = useMemo(() => [
    {
      text: undefined,
      items: [
        {
          icon: <LinkIcon className="link" />,
          label: "Copy link",
          id: "link",
        },
        {
          icon: <EmbedIcon className="embed" />,
          label: "Embed",
          id: "embed",
        },
      ],
    },
    {
      text: "Social share:",
      className: "socialShare",
      items: [
        {
          icon: <RedditIcon />,
          label: "Reddit",
          className: "reddit",
          id: "reddit",
        },
        {
          icon: <TwitterIcon />,
          label: "X",
          className: "twitter",
          id: "twitter",
        },
        {
          icon: <DiscordIcon />,
          label: "Discord",
          className: "discord",
          id: "discord",
        },
      ]
    },
  ], []);

  return <PopupMenu
    className="shareGifMenu"
    onClick={props.onClick}
    onClose={props.onClose}
    groups={menuItems}
  />;
});
